import { ReportEventType, type ReportEventDetail } from '@/types/report';

export function reportEventVideoStartSeconds(
    reportEvent: ReportEventDetail,
): number {
    if (reportEvent.type === ReportEventType.CUSTOM) {
        return reportEvent.videoStartSeconds ?? 0;
    }
    return reportEvent.frames[0]?.time ?? 0;
}
